import * as angular from "angular";
import {IController, IOnChangesObject} from "angular";

export class SchemaSelectComponent implements IController {

  formName?: string;
  selectedValue: any;
  options: any[];
  optionsWrapper: any;
  isRequired: boolean;
  isDisabled: boolean;
  excludeOptions: string[];
  isHideResetButton: boolean;
  isHideLabel: boolean;
  onChange: Function;

  public selectedText: string;

  constructor(private $mdPanel, private $filter) {
  }

  $onInit() {
    this._setFormName();
    this._setSelectedText();
  };

  $onChanges(changes: IOnChangesObject) {
    if (changes.selectedValue && !changes.selectedValue.isFirstChange()) {
      this._setSelectedText();
    }

    if (changes.formName && !changes.formName.isFirstChange()) {
      this._setFormName();
    }
  }


  onShowPanel($event) {

    if (!!this.isDisabled) {
      return;
    }

    const panelPosition = this.$mdPanel.newPanelPosition()
      .relativeTo($event.target)
      .addPanelPosition(
        this.$mdPanel.xPosition.CENTER,
        this.$mdPanel.yPosition.BELOW // yPosition.BELOW
      );

    const panelAnimation = this.$mdPanel.newPanelAnimation()
      .openFrom($event)
      .duration(200)
      .closeTo('.bringoz-select-input')
      .withAnimation(this.$mdPanel.animation.FADE);

    const selectedIdRef = this.selectedValue;
    const optionsRef = this.options;
    const optionsWrapperRef = this.optionsWrapper;
    const excludeIdsRef = this.excludeOptions;
    const isHideResetButtonRef = this.isHideResetButton;

    const config = {
      attachTo: angular.element(document.body),
      controllerAs: 'ctrl',
      position: panelPosition,
      animation: panelAnimation,
      targetEvent: $event,
      template: '<schema-select-filter-panel ' +
        'selected-id="ctrl.selectedIdRef" ' +
        'options="ctrl.optionsRef" ' +
        'options-wrapper="ctrl.optionsWrapperRef" ' +
        'panel-ref="ctrl.mdPanelRef" ' +
        'exclude-ids="ctrl.excludeIdsRef"' +
        'is-hide-reset-button="ctrl.isHideResetButtonRef">' +
        '</schema-select-filter-panel>',
      controller: function () {
        this.typeRef = 'custom'
        this.selectedIdRef = selectedIdRef;
        this.optionsRef = optionsRef;
        this.optionsWrapperRef = optionsWrapperRef;
        this.excludeIdsRef = excludeIdsRef;
        this.isHideResetButtonRef = isHideResetButtonRef;
      },
      clickOutsideToClose: true,
      escapeToClose: true,
      focusOnOpen: true,
      zIndex: 80,
      onCloseSuccess: (panel, selectedId, deleteSchemaId, duplicateSchemaId) => {
        if (selectedId === 'clickOutsideToClose' || selectedId === 'escapeToClose') {
          selectedId = selectedIdRef;
        }

        this.onChange({value: selectedId, deleteSchemaId: deleteSchemaId, duplicateSchemaId: duplicateSchemaId});

        panel.destroy();

      }
    };

    this.$mdPanel.open(config);
  }

  onResetFilter() {
    this.onChange({value: undefined});
  }

  private _setSelectedText() {
    if (this.selectedValue) {
      if (!this.optionsWrapper) {
        this.selectedText = this.$filter('translate')(this.selectedValue)
      } else {
        const selectedValueWrapperText = this.optionsWrapper.list.find(item => item.id === this.selectedValue)[this.optionsWrapper.propertyRef];
        this.selectedText = this.$filter('translate')(selectedValueWrapperText);
      }
    } else {
      this.selectedText = undefined;
    }
  }

  private _setFormName() {
    if (!this.formName) {
      this.formName = "schemaSelect"
    }
  }

}

angular
  .module('bringoz.admin.commons')
  .component('schemaSelect', {
    require: {
      form: '^form'
    },
    bindings: {
      formName: '<?',
      selectedValue: '<?',
      options: '<?',
      optionsWrapper: '<?',
      isRequired: '<?',
      isDisabled: '<?',
      excludeOptions: '<?',
      isHideLabel: '<?',
      onChange: '&?'
    },
    template: require('./schema-select.html').default,
    controller: SchemaSelectComponent
  });

